import React from "react"
import { Wrapper } from "./style"
import Icono1 from "../../../assets/images/alquiler/servicio1.svg"
import Icono2 from "../../../assets/images/alquiler/servicio2.svg"
import Icono3 from "../../../assets/images/alquiler/servicio3.svg"

const servicios = [
  {
    icon: Icono1,
    title: "Transporte Interno Mina",
    text: "Movilidad segura y certificada dentro de las operaciones mineras, cumpliendo con estándares de vehículos 4x4 y buses de alta montaña.",
  },
  {
    icon: Icono2,
    title: "Cambio de Turno",
    text: "Logística precisa para el relevo de personal masivo desde ciudades base hacia faenas, optimizando rutas y tiempos de descanso.",
  },
  {
    icon: Icono3,
    title: "Transporte Ejecutivo",
    text: "Vans exclusivas y SUVs para traslado de gerencia, visitas técnicas e inversionistas con conductores bilingües y servicio premium.",
  },
]

const ServiciosEspecializados = () => (
  <Wrapper>
    <div className="header" data-aos="fade-up" data-aos-duration="1000">
      <h2>Servicios Especializados</h2>
      <p>Adaptamos nuestra logística a las exigencias extremas de la faena y la normativa vigente</p>
    </div>
    <div className="grid container">
      {servicios.map((item, key) => (
        <div className="card" key={key} data-aos="fade-up" data-aos-duration="1000" data-aos-delay={key * 200}>
          <img className="card__icon" src={item.icon} alt={item.title} />
          <h3>{item.title}</h3>
          <p>{item.text}</p>
        </div>
      ))}
    </div>
  </Wrapper>
)

export default ServiciosEspecializados
